/* ====================================================================
   FLOOREVER — PAGE ÉCHANTILLON (sections/floorever-echantillon.liquid)
   Vanilla JS, chargé en defer. Réf. décor lue par le module panier
   commun (assets/floorever-cart.js, chargé sur toutes les pages).

   RÈGLE MÉTIER : data-max échantillons MAXIMUM PAR PANIER (3), pas par
   visite. Le quota se compte panier inclus, même détection que la fiche
   produit (floorever-product.js) : lignes gratuites de /cart.js
   (final_price == 0). Concrètement :
   - à l'init et à chaque retour sur l'onglet (visibilitychange), le
     panier est relu : les décors déjà au panier passent en .is-in-cart
     (bouton désactivé, libellé data-label-incart) et comptent dans le
     compteur « X / max » ;
   - un décor est reconnu par sa réf. FExxx, quelle que soit la gamme de
     l'échantillon au panier (ticket 3 de la recette) : FECH55308-ECH,
     ajouté depuis la fiche 55 Clic Plus, bloque la tuile FE308 même si
     elle pousse FEGH30308-ECH. Réf. lue dans le SKU, sinon en tête du
     titre, par FloorEverCart.refDecor, la règle des cartes et de la
     fiche ; repli sur l'id de variante sans réf. ou sans le module ;
   - la sélection est bloquée dès que (gratuits au panier + sélection)
     atteint le max — message calme, jamais de rouge ;
   - l'envoi groupé RE-vérifie le panier juste avant l'ajout (un autre
     onglet a pu consommer le quota) : doublons retirés en silence,
     dépassement refusé avec le message plafond, et si tout est déjà au
     panier on redirige simplement (l'objectif est atteint).

   Sélection multiple envoyée en UN seul /cart/add.js puis redirection
   vers le panier ou le paiement (data-apres).

   Progressive enhancement : sans JS, chaque carte reste un <form> qui
   poste nativement vers /cart/add (ajoute cet échantillon seul et
   navigue vers le panier) — le plafond n'est alors pas garanti côté
   client (Shopify ne sait pas le tenir côté serveur sans app).

   Contrat commun du thème (cf. floorever-product.js) : après ajout,
   mise à jour de la pastille panier du header (.cart-link .cart-count)
   et émission de document -> CustomEvent 'floorever:cart:change'.
   ==================================================================== */
(function () {
  'use strict';

  var NBSP = ' ';

  /* Réf. décor FExxx, identifiant du décor commun à toutes ses gammes :
     règle unique du module commun, FECH55308-ECH -> FE308. Chaîne vide
     sans le module : seul l'id de variante est alors comparé. */
  function refDecor(sku, titre) {
    var FC = window.FloorEverCart;
    return FC && FC.refDecor ? FC.refDecor(sku, titre) : '';
  }

  /* Met à jour la pastille du header et notifie le reste du thème. */
  function majCompteurPanier(routePanier) {
    /* Module commun (assets/floorever-cart.js) : pastille + événement, source normalisée. */
    if (window.FloorEverCart) return window.FloorEverCart.rafraichir(routePanier, 'echantillon');
    return fetch(routePanier, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var lien = document.querySelector('.cart-link');
        if (lien) {
          var compteur = lien.querySelector('.cart-count');
          if (!compteur && panier.item_count > 0) {
            compteur = document.createElement('span');
            compteur.className = 'cart-count';
            compteur.setAttribute('aria-hidden', 'true');
            lien.appendChild(compteur);
          }
          if (compteur) compteur.textContent = panier.item_count;
          lien.setAttribute(
            'aria-label',
            'Panier, ' + panier.item_count + ' article' + (panier.item_count > 1 ? 's' : '')
          );
        }
        document.dispatchEvent(
          new CustomEvent('floorever:cart:change', { detail: { cart: panier, source: 'echantillon' } })
        );
        return panier;
      })
      .catch(function () { /* silencieux : la pastille sera juste obsolète */ });
  }

  function initEch(root) {
    if (root.dataset.echInit === 'true') return;
    root.dataset.echInit = 'true';

    var max = parseInt(root.dataset.max, 10) || 3;
    var routeAjout = (root.dataset.routeCartAdd || '/cart/add') + '.js';
    var routePanier = (root.dataset.routeCart || '/cart') + '.js';
    var apres = root.dataset.apres === '/checkout'
      ? '/checkout'
      : (root.dataset.routeCart || '/cart');

    var bar = root.querySelector('[data-ech-bar]');
    var compteN = root.querySelector('[data-ech-n]');
    var submit = root.querySelector('[data-ech-submit]');
    var submitLabel = root.querySelector('[data-ech-submit-label]');
    var submitBase = submitLabel ? submitLabel.textContent.trim() : '';
    var statut = root.querySelector('[data-ech-status]');
    var cartes = Array.prototype.slice.call(root.querySelectorAll('[data-ech-card]'));

    var entrees = [];          /* toutes les cartes { id, ref, form, btn, label } */
    var selection = new Map(); /* id de variante -> entrée */
    var enPanier = new Set();  /* ids des variantes échantillon déjà au panier */
    var refsPanier = new Set(); /* réf. FExxx des échantillons déjà au panier */
    var gratuitsPanier = 0;    /* quantité totale de lignes gratuites au panier */
    var enCours = false;
    var minuteurStatut = null;

    /* Relit le panier et recalcule le quota consommé : lignes gratuites
       = échantillons (variantes à 0 €), même détection que la fiche. */
    function litPanier() {
      return fetch(routePanier, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (panier) {
          gratuitsPanier = 0;
          enPanier = new Set();
          refsPanier = new Set();
          (panier.items || []).forEach(function (item) {
            if (item.final_price === 0 || item.price === 0) {
              gratuitsPanier += item.quantity;
              enPanier.add(item.variant_id);
              var ref = refDecor(item.sku, item.product_title);
              if (ref) refsPanier.add(ref);
            }
          });
          return panier;
        });
    }

    /* Décor déjà au panier : même variante, ou même réf. FExxx venue
       d'une autre gamme. */
    function dejaAuPanier(entree) {
      return enPanier.has(entree.id) || (entree.ref !== '' && refsPanier.has(entree.ref));
    }

    /* Quota consommé = déjà au panier + sélection en cours. */
    function totalQuota() {
      return gratuitsPanier + selection.size;
    }

    function message(txt) {
      if (!statut) return;
      if (minuteurStatut) { clearTimeout(minuteurStatut); minuteurStatut = null; }
      statut.textContent = txt || '';
      statut.hidden = !txt;
      if (txt) {
        minuteurStatut = window.setTimeout(function () {
          statut.textContent = '';
          statut.hidden = true;
        }, 4000);
      }
    }

    function majBarre() {
      var n = selection.size;
      if (compteN) compteN.textContent = totalQuota();
      if (submit) submit.disabled = n === 0 || enCours;
      if (bar) bar.hidden = n === 0;
      if (bar && n > 0) root.classList.add('ech--barre');
      else root.classList.remove('ech--barre');
    }

    function majCarte(entree, actif) {
      entree.form.classList.toggle('is-selected', actif);
      if (entree.btn) {
        entree.btn.setAttribute('aria-pressed', actif ? 'true' : 'false');
        if (entree.label) {
          entree.label.textContent = actif
            ? (entree.btn.dataset.labelOn || 'Sélectionné')
            : (entree.btn.dataset.labelAdd || 'Ajouter');
        }
      }
    }

    /* Décor dont l'échantillon est déjà au panier : non re-sélectionnable
       (le retirer se fait au panier), compté dans le quota. */
    function marquerPanier(entree, dedans) {
      entree.form.classList.toggle('is-in-cart', dedans);
      if (dedans) entree.form.classList.remove('is-selected');
      if (entree.btn) {
        entree.btn.disabled = dedans;
        if (dedans) {
          entree.btn.setAttribute('aria-pressed', 'true');
          if (entree.label) {
            entree.label.textContent = entree.btn.dataset.labelIncart || 'Déjà dans le panier';
          }
        }
      }
    }

    /* Réconcilie cartes, sélection et compteur avec l'état réel du
       panier (init, retour d'onglet, juste avant l'envoi groupé). */
    function synchroniser() {
      entrees.forEach(function (entree) {
        var dedans = dejaAuPanier(entree);
        if (dedans && selection.has(entree.id)) selection.delete(entree.id);
        marquerPanier(entree, dedans);
        if (!dedans) majCarte(entree, selection.has(entree.id));
      });
      majBarre();
    }

    function basculer(entree) {
      if (entree.btn && entree.btn.disabled) return;
      var id = entree.id;
      if (selection.has(id)) {
        selection.delete(id);
        majCarte(entree, false);
        message('');
      } else {
        if (totalQuota() >= max) {
          message(statut ? statut.dataset.msgLimit : '');
          if (bar) bar.hidden = false; /* rend le message (et le compteur) visibles */
          return;
        }
        selection.set(id, entree);
        majCarte(entree, true);
        message('');
      }
      majBarre();
    }

    cartes.forEach(function (form) {
      var champId = form.querySelector('[name="id"]');
      var id = champId ? parseInt(champId.value, 10) : 0;
      if (!id) return;
      var entree = {
        id: id,
        ref: form.dataset.ref ? form.dataset.ref.toUpperCase() : refDecor(form.dataset.sku, ''),
        form: form,
        btn: form.querySelector('[data-ech-toggle]'),
        label: form.querySelector('[data-ech-toggle-label]')
      };
      entrees.push(entree);

      form.addEventListener('submit', function (e) {
        e.preventDefault(); /* repli sans JS : submit natif vers /cart/add */
        basculer(entree);
      });
    });

    if (submit) {
      submit.addEventListener('click', function () {
        if (enCours || selection.size === 0) return;
        enCours = true;
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        if (submitLabel) submitLabel.textContent = 'Ajout en cours…';
        message('');

        function rearmer() {
          enCours = false;
          submit.removeAttribute('aria-busy');
          if (submitLabel) submitLabel.textContent = submitBase;
          majBarre();
        }

        /* Revérifie le panier juste avant l'ajout : un autre onglet
           (fiche produit, panier) a pu consommer le quota entre-temps. */
        litPanier()
          .then(function () {
            synchroniser(); /* retire de la sélection ce qui est déjà au panier */

            var ids = [];
            selection.forEach(function (_entree, id) { ids.push(id); });

            if (ids.length === 0) {
              /* tout est déjà au panier : l'objectif est atteint */
              window.location.href = apres;
              return null;
            }
            if (gratuitsPanier + ids.length > max) {
              rearmer();
              message(statut ? statut.dataset.msgLimit : '');
              if (bar) bar.hidden = false;
              return null;
            }

            return fetch(routeAjout, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: ids.map(function (id) { return { id: id, quantity: 1 }; })
              })
            })
              .then(function (r) {
                if (!r.ok) throw new Error('ajout impossible (' + r.status + ')');
                return r.json();
              })
              .then(function () {
                return majCompteurPanier(routePanier);
              })
              .then(function () {
                if (submitLabel) submitLabel.textContent = '✓' + NBSP + 'C\'est parti…';
                window.location.href = apres;
              });
          })
          .catch(function () {
            rearmer();
            message(statut ? statut.dataset.msgError : '');
          });
      });
    }

    /* ---------------- Filtres par famille de décors ----------------
       Rendus hidden côté serveur (inutiles sans JS), révélés ici.
       Filtrage 100 % client : attribut hidden sur les cartes hors
       famille. La sélection en cours SURVIT au filtre (une carte
       sélectionnée puis masquée reste comptée — voulu). */
    var filtres = root.querySelector('[data-ech-filtres]');
    if (filtres) {
      filtres.hidden = false;
      filtres.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ech-filtre]');
        if (!btn) return;
        var famille = btn.dataset.famille || '';
        filtres.querySelectorAll('[data-ech-filtre]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        cartes.forEach(function (form) {
          form.hidden = famille !== '' && form.dataset.famille !== famille;
        });
      });
    }

    majBarre();

    /* État initial : quota déjà consommé + décors déjà au panier. */
    litPanier().then(synchroniser).catch(function () { /* dégradé : sélection seule */ });

    /* Retour sur l'onglet : l'utilisateur a pu ajouter/retirer des
       échantillons ailleurs (fiche, panier) — on resynchronise. */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && !enCours) {
        litPanier().then(synchroniser).catch(function () {});
      }
    });
  }

  function initTout(scope) {
    (scope || document).querySelectorAll('[data-ech]').forEach(initEch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTout(); });
  } else {
    initTout();
  }

  /* Rechargement de section dans l'éditeur de thème. */
  document.addEventListener('shopify:section:load', function (e) {
    initTout(e.target);
  });
})();
